<template>
  <div class="mb-download">
    <img :src="require('@/assets/mobile/chongdianapp.png')"/>
    <img class="qrcode" :src="require('@/assets/mobile/qrcode.png')"/>
    <p class="qr_desc">扫码下载国恒充电APP</p>
    <div class="desc">
      <div class="title">国恒充电APP</div>
      <div class="prompt">下载国恒充电APP，随时随地为爱车充电</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'download'
}
</script>
<style lang="less">
.mb-download{
  position: relative;
  width: 100%;
  height: 11.57rem;
  img{
    width: 100%;
    height: 100%;
    &.qrcode{
      width: 2.1rem;
      height: 2.1rem;
      position: absolute;
      top: 3.07rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .qr_desc{
    width: 100%;
    text-align: center;
    font-size: 9px;
    color: #666;
    position: absolute;
    top: 5.28rem;
  }
  .desc{
    width: 100%;
    position: absolute;
    top: 1.04rem;
    left: 0;
    text-align: center;
    .title{
      font-size: 27px;
      line-height: 37.5px;
      color: #292929;
      margin-bottom: .18rem;
    }
    .prompt{
      font-size: 16px;
      line-height: 20px;
      color: #666;
    }
  }
}
</style>
